// Products whose new schedules start with an empty type order, so the admin adds
// the types in the order they should run: Classic and Elite. Every other product
// starts with all its linked types. Calendar Settings and Schedule Calendar both
// use this, so the two pages stay in step.
const MANUAL_TYPE_ORDER = ['PROD-A', 'PROD-D'];

export const startingTypeOrder = (productId, linkedTypes) =>
  (MANUAL_TYPE_ORDER.includes(productId) ? [] : linkedTypes);
